import { useState, useRef, useLayoutEffect } from 'preact/hooks';

import { Button } from '~/components/Button';
import * as styles from './NSFWDialog.css';


const key = 'nsfwConsent';
const value = 'yes';
const consented = localStorage.getItem(key) === value;

export const NSFWDialog = () => {
	if (consented) {
		return null;
	}

	const [isOpen, setIsOpen] = useState(!consented);
	const [isChecked, setIsChecked] = useState(false);
	const ref = useRef();

	const handleConfirm = () => {
		setIsOpen(false);
		localStorage.setItem(key, value);
	};

	const handleCheckChange = () => {
		setIsChecked(!isChecked);
	};

	const handleClose = (ev) => {
		ev.preventDefault();
	};

	useLayoutEffect(() => {
		/** @type {HTMLDialogElement} */
		const dialog = ref.current;

		if (isOpen) {
			dialog.returnValue = '';
			dialog.showModal();
		}
		else if (dialog.open) {
			dialog.close();
		}
	}, [isOpen]);


	return (
		<dialog ref={ref} className={styles.dialog} oncancel={handleClose}>
			<h1>Content warning!</h1>
			<p>
				The content available on this website may contain pornographic material
				and by proceeding, you confirm that you are of legal age to view.
			</p>

			<div className={styles.actions}>
				<label className={styles.checkbox}>
					<input type='checkbox' value={isChecked} onChange={handleCheckChange} />
					Yes, I confirm.
				</label>

				<Button onClick={handleConfirm} disabled={!isChecked} variant='primary'>
					Continue
				</Button>
			</div>
		</dialog>
	)
}
